exports = module.exports = {
  facebook : {
  	appId : 142334583177233,
  	secret : 'e34071636244a2f295fd9319df87a459'
  }
  /*facebook : {
  	appId : 348774558910174,
    secret : 'd324c86cc4a7191820e9c34e51da6b82'
  }*/
};


//////////////////
// WEBPACK FOOTER
// ./config.js
// module id = 16
// module chunks = 0